import type { KnowledgeParticleRemark, KnowledgeParticleRemarkContent } from '../types/domain';
import { apiClient } from './apiClient';

export const defaultRemarkContent: KnowledgeParticleRemarkContent = {
  pitfalls: {},
  breakthroughs: {},
  stuckpoints: {},
  analogies: {},
  others: {},
  ref: {},
};

export const learningRecordService = {
  async getLearningRecord(particleId: string, userId: string) {
    const params = new URLSearchParams({ userId });
    const payload = await apiClient.requestJson<{
      success?: boolean;
      data?: KnowledgeParticleRemark | null;
      default_content?: KnowledgeParticleRemarkContent;
      error?: string;
    }>(`/api/knowledge-particles/${particleId}/remarks?${params}`, { auth: true });

    if (!payload.success) throw new Error(payload.error || '获取学习记录失败');
    return {
      remark: payload.data ?? null,
      defaultContent: payload.default_content ?? defaultRemarkContent,
    };
  },

  async saveLearningRecord(input: {
    particleId: string;
    userId: string;
    remarkContent: KnowledgeParticleRemarkContent;
  }) {
    const payload = await apiClient.requestJson<{ success?: boolean; data?: KnowledgeParticleRemark; error?: string }>(
      `/api/knowledge-particles/${input.particleId}/remarks`,
      { method: 'POST', body: { userId: input.userId, remarkContent: input.remarkContent }, auth: true },
    );
    if (!payload.success || !payload.data) throw new Error(payload.error || '保存失败');
    return payload.data;
  },
};
